module.exports = __webpack_public_path__ + "static/img/zhwh.e92e1d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhwh.png
// module id = fP5M
// module chunks = 2